import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import api from '../services/api.js'
import { useAuthStore } from './auth.js'

// Теги для Избранного: свой список у каждого пользователя (сервер —
// lib/favTags.js). Грузится один раз; правка списка в «Настройках Дневника»
// уходит на сервер целиком и возвращается уже очищенной.
export const useFavTagsStore = defineStore('favTags', () => {
  const tags = ref([])
  const maxLength = ref(20)
  const maxTags = ref(30)
  const loaded = ref(false)
  let loading = null

  // Показ тегов в дневнике и «Кулинарии» — переключатель в настройках дневника
  const enabled = computed(() => useAuthStore().user?.diary_settings?.show_fav_tags !== false)

  async function load(force = false) {
    if (loaded.value && !force) return
    if (loading) return loading
    loading = api.get('/diary/fav-tags')
      .then(({ data }) => {
        tags.value = data.tags || []
        if (data.max_length) maxLength.value = data.max_length
        if (data.max_tags) maxTags.value = data.max_tags
        loaded.value = true
      })
      .catch(() => {})
      .finally(() => { loading = null })
    return loading
  }

  async function save(list) {
    const { data } = await api.put('/diary/fav-tags', { tags: list })
    tags.value = data.tags || []
    loaded.value = true
    return data
  }

  async function setDishTags(dishId, list) {
    const { data } = await api.put(`/diary/dishes/${dishId}/tags`, { tags: list })
    return data.tags || []
  }

  return { tags, maxLength, maxTags, loaded, enabled, load, save, setDishTags }
})
